import { DialogActions, DialogContent, DialogTitle, TextField } from "@material-ui/core";
import styled from "styled-components";

import { Button } from "js/Components/Button";
import { defaultText } from "js/textStyles";

import BeautifulDialog from "./BeautifulDialog";

export const WorkspaceDialog = styled(BeautifulDialog)`
    &&& {
        .MuiDialog-paper {
            padding: 40px 50px;
            gap: 20px;
            margin: 0;
        }
    }
`;

export const WorkspaceDialogBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
    align-self: stretch;
`;

export const WorkspaceDialogTitle = styled(DialogTitle)`
    &.MuiDialogTitle-root {
        padding: 0;
    }

    h2 {
        ${defaultText}
        color: #333;
        font-size: 23px;
        font-weight: 600;
        line-height: 120%;
        text-align: left;
    }
`;

export const WorkspaceDialogContent = styled(DialogContent)`
    &.MuiDialogContent-root {
        padding: 0;
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 20px;
        overflow: visible;
    }
`;

export const WorkspaceDialogField = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;
    align-self: stretch;
    width: 100%;

    .invite-input,
    .react-tagsinput {
        width: 100%;
    }
`;

export const WorkspaceDialogFieldLabel = styled.label`
    color: #999;
    font-family: "Source Sans Pro";
    font-size: 10px;
    font-weight: 400;
    line-height: 150%;
`;

export const WorkspaceDialogTextField = styled(TextField)`
    &&& {
        color: #222;
        font-family: "Source Sans Pro";
        font-size: 14px;
        font-weight: 400;
        line-height: 150%;
    }
`;

export const WorkspaceDialogActions = styled(DialogActions)`
    &.MuiDialogActions-root {
        justify-content: flex-end;
        padding: 0;
        margin: 0;
        gap: 20px;
    }
`;

export const WorkspaceDialogActionButton = styled(Button)`
    &&& {
        margin: 0;
        padding: 6px 16px;
    }
`;
